import React from 'react'

import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'

import {  getPayrollsEmployes } from '../../../../../../MyApi/sb/employes'


import LoadingSpinner from '../../../../../UI/spinner'
import SingleEmployesPayrolls from './singlePayrolls'

const EmployesPayrolls = ({id}) => {
    const {t}= useTranslation()
    const {data , isLoading} = useQuery(["getPayrollsEmployes",id] , ()=>getPayrollsEmployes(id))
    const employesPayrolls = data?.data || []

    if(isLoading){
        return <LoadingSpinner/>
    }
    if(!data){
        return <div>no data avalible</div>
    }
  
   
    
  return (   
  
    <table className="table-responsive-sm table table-striped table-hover">
  <thead >    
           <th>#</th> 
            <th>{t("desreved amount")}</th> 
            <th>{t("undeserved_amount")}</th>
            <th>{t("extra_amount")}</th>
            <th>{t("discount_amount")}</th>
            <th>{t("loan_amount")}</th>
            <th>{t("status")}</th>
  </thead>
<tbody>
  {employesPayrolls.map((employe)=>(
    <SingleEmployesPayrolls key={employe.id} {...employe}/>
  ))  }

</tbody>
</table> 

  )
}

export default EmployesPayrolls